import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import * as H from 'history'

/**
 * 监听路由发生变化
 * @param callback 回调函数
 */
export function useLocationChange<S = H.LocationState>(
    callback: (val: H.Location<S>, old: H.Location<S>) => void,
) {
    const location = useLocation<S>()
    const [old, setOld] = useState(location)
    useEffect(() => {
        callback(location, old)
        setOld(location)
    }, [location])
}
